import type { ApolloError } from '@apollo/client';
import { createContext, useContext } from 'react';

export type CheckSingleSignOnEmail = (email: string) => Promise<boolean>;

type SingleSignOnContext = {
  email?: string;
  error?: ApolloError;
  isEnabled: boolean;
  isLoading: boolean;
  isActive: boolean;
  checkEmail: CheckSingleSignOnEmail | null;
  signInUrl?: string | null;
  redirectPath?: string;
};

const defaultValue: SingleSignOnContext = {
  isEnabled: false,
  isLoading: false,
  isActive: false,
  checkEmail: null,
};

const context = createContext(defaultValue);
const { Provider } = context;
const useSingleSignOn = (): SingleSignOnContext => useContext(context);

export { SingleSignOnContext, Provider, defaultValue, useSingleSignOn };
